/**
 * @Description: 产品面向的客户信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  CustomerModel,
  CustomerSearchModel,
  CustomerPageSearchModel,
  CustomerAddModel,
  CustomerUpdateModel,
  IdsModel
} from '@/model/product/CustomerModel'

const baseUrl = Route.product + '/customer'

/**
 * 搜索分页数据
 */
export const pageSearchCustomer = (param: CustomerPageSearchModel) => {
  return https().request<RootObject<PageRespModel<CustomerModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchCustomer = (param: CustomerSearchModel) => {
  return https().request<RootObject<CustomerModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getCustomer = (id: number) => {
  return https().request<RootObject<CustomerModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addCustomer = (param: CustomerAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateCustomer = (param: CustomerUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeCustomer = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveCustomer = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
